import { genericGet, genericPost } from "./base.api";
import { getDataApiUrl } from "utils/utils";
import { Device, DeviceListResponse } from "types/device";
import { DownloadJobStatusResponse } from "types/asset";
import { getRandomLocation } from "./map.api";
import { random } from "lodash";

export function getDeviceList(params?: Record<string, any>): Promise<DeviceListResponse> {
  return genericGet(`${getDataApiUrl()}/localized/devices`, params)
  // .then((res: DeviceListResponse) => {
  //   res.items.forEach(r => r.location = getRandomLocation())
  //   return res
  // });
}

export function getDeviceInfo(device_id: string): Promise<Device> {
  return genericGet(`${getDataApiUrl()}/localized/device_full`, { device_id })
  // .then((device: Device) => {
  //   const lst = [
  //     { type: "device_user", user_id: "test", name: "shabi" },
  //     { type: "invalid_authorization_device_user" },
  //     null]
  //   device.user = lst[random(0, 2)]
  //   return device
  // })
}

export function CreateLogExportJob(start_date: string, end_date: string): Promise<{ job_id: string }> {
  const queryString = new URLSearchParams();
  queryString.append('start_date', start_date);
  queryString.append('end_date', end_date);
  return genericPost(`${getDataApiUrl()}/event/change/device/export/job?${queryString.toString()}`, null)
};

export function GetLogExportJobStatus(jobId: string | null): Promise<DownloadJobStatusResponse> {
  return genericGet(`${getDataApiUrl()}/event/change/device/export/job/${jobId}/status`)
};
